import { GoPeriodsSMPage } from "../goPeriodsSM/goPeriodsSM";
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavParams, Tabs, Events, ToastController, NavController, App } from 'ionic-angular';
import { LotteryPage } from "../lottery/lottery";
import { GoPeriodsPage } from "../goPeriods/goPeriods";
import { LotteryHistoryPage } from "../lotteryHistory/lotteryHistory";
import { GoPeriodsMMCPage } from "../goPeriodsMMC/goPeriodsMMC";
import { TaiXiuPage } from "../TaiXiu/TaiXiuPage";
import { XocDiaPage } from "../XocDia/XocDiaPage";
import * as common from '../../directives/common';
import { AppDialog } from "../../component/appDialog";

@Component({
    templateUrl: 'lotteryTabPanel.html',
    selector: 'lottery-tabs-page',
})
export class LotteryTabsPage implements OnInit, OnDestroy {
    static hasInit: boolean = false;
    private pageDom: HTMLElement;
    public tab1Root: any;
    public tab2Root: any;
    public LotteryPageRoot: any;
    private isTabChangeProcessing: boolean = false;

    @ViewChild('myTabs') tabRef: Tabs;
    private lotteryInitParams: any;
    public showXoa = false;
    public getGameID: any;
    public indextab: any = 2;
    private isCleaned = false; // Thêm một cờ trạng thái
    public is1Giay: boolean = true;
    totalBetMoney = 0;
    constructor(public events: Events, public el: ElementRef, public params: NavParams,
        private navCtrl: NavController,
        public app: App,
        private toastCtrl: ToastController) {

        let lotteryName = this.params.get('lotteryName');
        this.pageDom = el.nativeElement;
        this.tab1Root = LotteryHistoryPage;
        this.getGameID = this.params.data.lotteryId;
        if ((this.getGameID == 80 || this.getGameID == 60)) {
            this.showXoa = true;
        }
        if (LotteryPage.betMoney == 0 && TaiXiuPage.betMoney === 0) {
            this.totalBetMoney = 0;
        } else {
            this.totalBetMoney = TaiXiuPage.betMoney
        }

        if (lotteryName === "MMC" || lotteryName === "tx1phut") {
            this.tab2Root = GoPeriodsMMCPage;
        } else {
            this.tab2Root = GoPeriodsPage;
        }

        if (common.checkGameTaiXiu(this.params.data.lotteryId)) { // page game Tai-Xiu
            this.LotteryPageRoot = TaiXiuPage;
            if (Number(this.getGameID) === 80) { // is game 1phut taixiu
                // this.is1Giay = false;
                this.is1Giay = true;
            }
        } else if (common.checkGameXocDia(this.params.data.lotteryId)) {
            this.LotteryPageRoot = XocDiaPage;
        } else {
            this.LotteryPageRoot = LotteryPage;
        }

        this.lotteryInitParams = {
            lotteryName: this.params.get('lotteryName'),
            title: this.params.get('title'),
            lotteryId: this.params.get('lotteryId'),
            titleGame: this.params.get('titleGame')
        };
        LotteryTabsPage.hasInit = true;
    }

    goNumber() {
        // console.log('====================================');
        // console.log('go');
        // console.log('====================================');
        // this.app.getRootNav().push(this.tab2Root);
        // this.navCtrl.push(this.tab2Root)
        // this.navCtrl.push(this.tab2Root, {}, { animate: false });
        this.events.publish('issues:goPage', {
            gameID: this.lotteryInitParams.lotteryId
        });
    }
    ngOnInit() {

      

    }
    ionViewWillEnter() {
        this.isCleaned = false; 
        this.isTabChangeProcessing = false; // Reset trạng thái khi vào lại page

    }
    ngOnDestroy() {
        // this.navCtrl.pop();
        // this.navCtrl.pop();
        const tabs = document.querySelector('#myTabs');
        if (tabs) {
            tabs.remove(); // Loại bỏ element khỏi DOM
        }
    }
    clearChip() {
        console.log('====================================');
        console.log('clearChip--12312');
        console.log('====================================');
            this.events.publish('taixiu:Clean');
    }

    ionViewDidLeave() {
        LotteryTabsPage.hasInit = false;
        this.isTabChangeProcessing = false; // Reset trạng thái khi vào lại page

    }




    changeTab(ionChange) {
        this.indextab = ionChange.index;
    
        if (this.showXoa) {
            if (this.indextab != 2 && this.indextab != 3) {
                this.toggleTabVisibility(false);
            } else {
                this.toggleTabVisibility(true);
            }
        }
    
        if (ionChange.index == 0) {
            this.pageDom.querySelector('#lottery-submit').className = 'hide';
        } else {
            if (ionChange.index == 3) {
                console.log('ionChange.index', ionChange.index);
                this.clearChip();
            } else {
                this.pageDom.querySelector('#lottery-submit').className = 'submit';
            }
        }
    }
    
    private toggleTabVisibility(show: boolean) {
        const visibilityClass = show ? 'show' : 'hide';
        ['#tab-t1-3', '#tab-t2-3', '#tab-t3-3'].forEach((selector) => {
            const element = this.pageDom.querySelector(selector);
            if (element) {
                element.className = `tab-button has-title has-icon disable-hover ${visibilityClass}`;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/lotteryTabPanel/lotteryTabPanel.ts